import Immutable from 'immutable';
import {ActionTypes} from './actions';

const initial = Immutable.fromJS({
    width: 0,
    height: 0,
    duration: 0,
    currentTime: 0,
    currentTimeNormalized: 0,
    seeked: false,
});

export const reducer = (state = initial, action) => {
    switch (action.type) {
        case ActionTypes.SET_VIDEO_DURATION:
            return state.set('duration', action.duration);

        case ActionTypes.SET_VIDEO_DIMENSIONS:
            return state.merge({
                width: action.width,
                height: action.height,
            });

        case ActionTypes.SET_PLAYHEAD:
            return state.merge({
                currentTime: action.currentTime,
                currentTimeNormalized: action.currentTime / state.get('duration'),
            });

        case ActionTypes.SEEKING:
            return state.merge({
                seeked: true,
                currentTime: action.time,
                currentTimeNormalized: action.time / state.get('duration'),
            });

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./scripts/store/video/reducer.js